import { render, staticRenderFns } from "./PatentUpdateFields.vue?vue&type=template&id=3b693cc4&"
import script from "./PatentUpdateFields.vue?vue&type=script&lang=js&"
export * from "./PatentUpdateFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports